import { QuoteSubmitorDesktop, QuoteSubmitorMobile } from './QuoteSubmitLayout';

export const QuoteSubmitor = ({ size }: { size?: 'desktop' | 'mobile' }) => {
  if (size === 'mobile') {
    return <QuoteSubmitorMobile />;
  } else {
    return <QuoteSubmitorDesktop />;
  }
};
